"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VRView = void 0;
const react_1 = __importStar(require("react"));
const { PanoViewer } = require("@egjs/view360");
const styled_components_1 = __importDefault(require("styled-components"));
require("../style.scss");
const colors_1 = __importDefault(require("../../../../scss/colors"));
const ViewWrapper = styled_components_1.default.div `
    width: 100%;
    height: 100%;
`;
const Skybox = styled_components_1.default.div `
    width: 100%;
    height: 100%;
`;
const IPhonePortraitMessage = styled_components_1.default.div `
    position: fixed;
    width: 100%;
    height: 100%;
    background: ${colors_1.default.VRBackground};
    color: ${colors_1.default.VRText};
    display: ${(props) => props.isVisible ? "block" : "none"};
    z-index: 99999;
    top: 0;
    left: 0;
    pointer-events: all;
    & > img {
        margin-top: 55%;
        width: 30%;
        margin-left: 37%;
    }
    & > h4 {
        margin-top: 10%;
        text-align: center;
    }
    & :after {
        content: "×";
        position: fixed;
        top: 20px;
        right: 20px;
    }
`;
class VRView extends react_1.Component {
    constructor(props) {
        super(props);
        this.skybox = (0, react_1.createRef)();
        this.componentDidMount = () => {
            // You can only specify _one of_ video or image:
            // https://naver.github.io/egjs-view360/release/3.4.0/doc/eg.view360.PanoViewer.html
            const options = this.props.videoSrc
                ? { useZoom: false, video: this.props.videoSrc }
                : { useZoom: false, image: this.props.imgSrc };
            const panoViewer = new PanoViewer(this.skybox.current, options);
            this.viewer = panoViewer;
            // If this is a slave viewer and we're not looking at an image
            if (this.props.masterVideo && !this.props.imgSrc) {
                this.viewer.setVideo(this.props.masterVideo);
            }
            if (this.props.isMobile) {
                // When the user presses the launch button we request access to the
                // gyroscope on iOS (other mobile platforms just let us have access).
                // Where or not the user gives us permission is passed through so we
                // can use it here. We use it to decide what "mode" to set the gyroscope
                // to. "VR" makes the sim move around when the user moves their device,
                // and "yawPitch" only moves the sim if the user drags it with their
                // finger.
                if (this.props.useGyro) {
                    this.viewer
                        .enableSensor()
                        .then(() => {
                        this.viewer.setGyroMode("VR");
                    })
                        .catch((e) => {
                        console.error(`Failed to enable PanoViewer sensor: ${e}`);
                    });
                    this.viewer.setGyroMode("yawPitch");
                }
                else {
                    this.viewer.setGyroMode("yawPitch");
                }
            }
            else {
                this.viewer.setGyroMode("none");
            }
            this.viewer.on("ready", () => {
                this.props.viewerReady(this.viewer.getVideo());
            });
            // get our view direction
            if (this.props.getView) {
                this.viewer.on("viewChange", (event) => {
                    this.props.getView(event);
                });
            }
            // Add resizer
            window.addEventListener("resize", () => {
                this.updateViewportDimensions();
            });
            // watch for landscape
            window.addEventListener("orientationchange", () => {
                this.setState({
                    orientation: window.orientation,
                });
                this.updateViewportDimensions();
            });
        };
        this.state = {
            orientation: window.orientation,
        };
    }
    render() {
        return (react_1.default.createElement(ViewWrapper, null,
            react_1.default.createElement(Skybox, { ref: this.skybox, onMouseDown: this.props.onMouseDown }),
            react_1.default.createElement(IPhonePortraitMessage, { onClick: this.props.exitStereo, isVisible: !!(this.props.isStereoscopic &&
                    (this.state.orientation === "portrait" ||
                        this.state.orientation === 0)) },
                react_1.default.createElement("img", { src: require("../assets/ic_rotatedevice.svg") }),
                react_1.default.createElement("h4", null, "Insert your phone into a Cardboard"))));
    }
    componentDidUpdate() {
        if (!this.viewer._isReady)
            return;
        this.updateViewportDimensions();
    }
    updateViewportDimensions() {
        if (this.viewer._container.offsetWidth !== undefined &&
            this.viewer._container.offsetWidth !== 0 &&
            this.viewer._container.offsetHeight !== undefined &&
            this.viewer._container.offsetHeight !== 0) {
            this.viewer.updateViewportDimensions({
                width: this.viewer._container.offsetWidth,
                height: this.viewer._container.offsetHeight,
            });
        }
    }
}
exports.VRView = VRView;
exports.default = VRView;
